(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name : view dwt detail service
   * @returns : rest calls to view dwt detail, creating JSON request objects for
   *          service calls.
   * @description : Service to view dwt detail.
   */
  angular.module('dwtModule').factory('ViewDwtDetailService', [
    '$http',
    '$sessionStorage',
    '$resource',
    function ($http, $sessionStorage, $resource) {
      return {
        getPaymentDetailsOverview: function (eventId) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: 'v1/dwtpayments/' + eventId + '/paymentDetails',
            method: 'GET',
          });
        },
        getQrfPaymentDetails: function (eventId) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: 'v1/dwtpayments/' + eventId + '/qrf-payment-details',
            method: 'GET',
          });
        },
        pePaymentCompletedAction: function (requestBody) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url:
              `v1/dwtevents/${requestBody.eventId}/dwtclaims/payment/disburse`,
            method: 'POST',
            data: requestBody,
          });
        },
        qrfPaymentCompletedAction: function (dwtEventId, invoiceId, intermediaryId) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url:
              `v1/dwtevents/${dwtEventId}/confirm-payment-made`,
            method: 'POST',
            data: {
              invoiceId: invoiceId,
              intermediaryId: intermediaryId
            },
          });
        },
        pePaymentReceivedAction: function (requestData) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: `v1/dwtevents/${requestData.eventId}/dwtclaims/payment/confirm`,
            method: 'POST',
            data: requestData,
          });
        },
        qrfPaymentReceivedAction: function (dwtEventId, invoiceId, intermediaryId) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: `v1/dwtevents/${dwtEventId}/confirm-payment-received`,
            method: 'POST',
            data: {
              invoiceId: invoiceId,
              intermediaryId: intermediaryId
            },
          });
        },
        getDWTClaimDetailsOverview: function (
          eventId,
          pageNumber
        ) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url:
              `v1/taxreclaim/${eventId}/dwt-claims?pageNumber=${pageNumber}&pageSize=1000`,
            method: 'GET',
          });
        },
        getDwtDetailsOverview: function (eventId, userType, languageCode) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url:
              'v1/taxreclaim/' +
              $sessionStorage.groupId +
              '/' +
              eventId +
              '/' +
              userType +
              '/' +
              languageCode +
              '/events',
            method: 'GET',
          });
        },
        updateEventComments: function (commentsData, authtoken) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Internal-Auth-Token': authtoken,
            },
            url: 'v1/taxreclaim/comments',
            method: 'POST',
            data: commentsData,
          });
        },
        submitClaims: function (claimsIdList) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            url: 'v1/taxreclaim/submit',
            method: 'POST',
            data: claimsIdList,
          });
        },
        toBeAuthorizeSubmitClaims: function (claimsToSubmit) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: 'v1/dwtevents/' + claimsToSubmit.dwtEventId + '/dwtclaims/authorize',
            method: 'POST',
            data: claimsToSubmit,
          });
        },
        undoSubmitOrReject: function (undoData, authtoken) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Internal-Auth-Token': authtoken,
            },
            url: 'v1/taxreclaim/undo',
            method: 'POST',
            data: undoData,
          });
        },
        getDwtClaimsDetailsView: function (claimId, userType, eventId) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url:
              'v1/taxreclaim/' +
              $sessionStorage.groupId +
              '/' +
              claimId +
              '/' +
              eventId +
              '/' +
              userType +
              '/view',
            method: 'GET',
          });
        },
        getDwtToBeAuthorizedData: function (eventId) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: `v1/dwtevents/${eventId}/claims-to-authorize`,
            method: 'GET',
          });
        },
        getDwtGetEmailData: function (eventId) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: 'v1/dwtevents/' + eventId + '/sendtotaxauthority/data ',
            method: 'GET',
          });
        },
        sendDWTEmail: function (eventId, userId) {
          var reqData = {
            loggedInUserId: userId,
          };
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: 'v1/dwtevents/' + eventId + '/sendtotaxauthority',
            method: 'POST',
            data: reqData,
          });
        },
        rejectClaim: function (rejectData, authtoken) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Internal-Auth-Token': authtoken,
            },
            url: 'v1/taxreclaim/reject',
            method: 'POST',
            data: rejectData,
          });
        },
        deleteClaim: function (eventId, claimId, authtoken) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Internal-Auth-Token': authtoken,
            },
            url: 'v1/dwtevents/' + eventId + '/dwtclaims/' + claimId,
            method: 'DELETE',
          });
        },
        deleteClaimForm: function (formId, formType, authtoken) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Internal-Auth-Token': authtoken,
            },
            url: 'v1/claimforms/' + formId + '/' + formType + '/delete',
            method: 'DELETE',
          });
        },
        getExtensionRequestStatus: function (intermediaryId, eventId) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url:
              'v1/extensionrequest/' +
              intermediaryId +
              '/' +
              eventId +
              '/status',
            method: 'GET',
          });
        },
        requestQrfPayment: function (eventId, paymentData) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            url: 'v1/dwtevents/' + eventId + '/dwtclaims/payment/request/qrf',
            method: 'POST',
            data: paymentData,
          });
        },
        viewClaimForms: function (userId, formId, formType) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              responseType: 'arraybuffer',
            },
            url:
              'v1/claimforms/' +
              userId +
              '/' +
              formId +
              '/' +
              formType +
              '/view',
            method: 'GET',
          });
        },
        getCurrentCETTime: function () {
          return $resource(
            'v1/shareholderusers/timestamp',
            {},
            {
              query: {
                method: 'GET',
                isArray: true,
              },
            }
          );
        },
        getShareholderList: function (
          issuerId,
          prodCode,
          langCode,
          userId,
          eventId
        ) {
          return $resource(
            'v1/peshareholders/issuer/' +
              issuerId +
              '/' +
              prodCode +
              '/' +
              userId +
              '/' +
              eventId +
              '/event',
            {},
            {
              query: {
                method: 'GET',
              },
            }
          );
        },
      };
    },
  ]);
})();
